
import Vue from "vue"
import {Component, Inject, Prop} from "vue-property-decorator"
import DateRangeSelect from "@/superannuation/DateRangeSelect.vue"
import {DateRangeSelector} from "@/DateRangeSelector"
import {PlanService} from "@/superannuation/PlanService"
import {QItem, QList, QMenu} from "quasar"
import {AuthenticationService} from "@/AuthenticationService"
import SelectPlanDropDown from "@/components/SelectPlanDropDown.vue"
import {mixin as clickaway} from "vue-clickaway"
import {CalculationVariableService} from "@/CalculationVariableService"

@Component({
  mixins: [clickaway],
  components: {
    DateRangeSelect,
    SelectPlanDropDown,
    QMenu,
    QList,
    QItem,
  },
})
export default class PageHeader extends Vue {
  @Prop()
  dateRangeSelector: DateRangeSelector

  @Prop({default: true})
  isPlanSelectable: boolean

  @Prop({default: false})
  loading: boolean

  @Inject()
  planService: PlanService

  @Inject()
  authenticationService: AuthenticationService

  @Inject()
  calculationVariableService: CalculationVariableService

  planSelectionOpen = false
  isCompanyRep: boolean | null = <any>null

  async created() {
    const user = await this.authenticationService.loadCurrentUser()

    if (user == null) {
      await this.$router.push("/login")
    } else {
      await this.calculationVariableService.get()

      if (user.role === "CompanyRep") {
        await this.planService.load()
        this.isCompanyRep = true
      } else {
        this.isCompanyRep = false
        this.planSelectionOpen = this.planService.current === null
      }
    }
  }

  get isGoBackVisible() {
    return !this.$route.fullPath.endsWith("/dashboard")
  }

  get showPlanName() {
    return !this.planSelectionOpen
  }

  openPlanSelection() {
    if (
      this.isCompanyRep !== null &&
      !this.isCompanyRep &&
      this.isPlanSelectable &&
      !this.loading
    ) {
      this.planSelectionOpen = true
    }
  }

  closePlanSelection() {
    if (this.planService.current !== null) {
      this.planSelectionOpen = false
    }
  }
}
